import { render, staticRenderFns } from "./exPsuIndex.vue?vue&type=template&id=064183fc&scoped=true"
import script from "./exPsuIndex.vue?vue&type=script&lang=js"
export * from "./exPsuIndex.vue?vue&type=script&lang=js"
import style0 from "./exPsuIndex.vue?vue&type=style&index=0&id=064183fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064183fc",
  null
  
)

export default component.exports